module.exports = __webpack_public_path__ + "img/124.c8f1a679.jpg";